module.exports = __webpack_public_path__ + "static/media/radiantChic.4e23b40a.gif";